import 'regenerator-runtime'; /* for async await transpile */
import '../styles/main.scss';
import '../styles/responsive.scss';
import swRegister from './utils/swRegister';
import App from './views/app';

const app = new App({
  button: document.querySelector('#hamburgerButton'),
  drawer: document.querySelector('#navigationDrawer'),
  content: document.querySelector('#container'),
});

window.addEventListener('hashchange', () => {
  app.renderPage();
});

window.addEventListener('load', () => {
  app.renderPage();
  swRegister();
  // skip to content
  const skipToContent = document.querySelector('.skip_to_content');
  skipToContent.addEventListener('click', (event) => {
    event.preventDefault();
    document.getElementById('container').scrollIntoView({behavior: 'smooth'});
    skipToContent.blur();
  });
});
